import { Gender, PersonNameDto, PhoneNumberDto } from './contactConfig'
import { ReplicationDto } from './emailConfig'
import { BaseTierDto } from './finance/financeConfig'

export type ShortUserListItemDto = {
    id: string
    fullName: string
    shortCode: string
}

export type UserListItemDto = ShortUserListItemDto & {
    email: string
    status: UserStatus
    useTimePopup: boolean
    tiers: BaseTierDto[]
}

export type UserDto = UserListItemDto & {
    name: PersonNameDto
    gender: Gender
    jobTitle: string
    locality: string
    signature: string
    phoneNumber: PhoneNumberDto
    // Contains the replication data of the shared mailbox.
    replication: ReplicationDto
}

export enum UserStatus {
    Enabled = 'ENABLED',
    EnabledUnfiltered = 'ENABLED_UNFILTERED',
    Disabled = 'DISABLED',
    Hidden = 'HIDDEN',
}

export const ActiveUserStatuses: UserStatus[] = [UserStatus.Enabled, UserStatus.EnabledUnfiltered]

export enum UserAction {
    GetList = 'GET_USER_LIST',
    ResetList = 'RESET_USER_LIST',
}
